import useGetAuthSessionQuery from '~/features/auth/hooks/useGetAuthSessionQuery'
import { ECognitoGroups } from '~/models/auth'
import { store } from '~/store'

const useUserAccess = () => {
  const { data: authSession } = useGetAuthSessionQuery()
  const userGroups = authSession?.groups || []
  const [orgPaymentTier, isImpersonated] = store((state) => [
    state.organization.paymentTier,
    !!state.user.impersonatorsUserId,
  ])

  const isFreePlan = orgPaymentTier === ECognitoGroups.customerFreePlan
  const isBasicFreeTrial =
    orgPaymentTier === ECognitoGroups.customerBasicFreeTrialPlan
  const isPlusUser = isImpersonated
    ? orgPaymentTier === ECognitoGroups.customerPlusPlan
    : userGroups.includes(ECognitoGroups.customerPlusPlan)
  const isBasicUser = isImpersonated
    ? orgPaymentTier === ECognitoGroups.customerBasicPlan
    : userGroups.includes(ECognitoGroups.customerBasicPlan)

  return { isFreePlan, isBasicFreeTrial, isPlusUser, isBasicUser }
}

export default useUserAccess
